// Standard Firebase v9+ initialization following modular SDK patterns
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDacfKl-1CD3MaclbV1pBMjaTNtAN3XIf8",
  authDomain: "hypertyper-9376e.firebaseapp.com",
  projectId: "hypertyper-9376e",
  storageBucket: "hypertyper-9376e.firebasestorage.app",
  messagingSenderId: "1084972230924",
  appId: "1:1084972230924:web:4bdeff9bc0a228f7db4129",
  measurementId: "G-TCTXLK7270"
};

// Initialize Firebase with the provided configuration using the modular SDK
// Fix: Use the named export initializeApp from the standard firebase/app module
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);